/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `ai` - AI 생성
 * `uploaded` - 직접 업로드
 * `arrangement` - 어레인지먼트
 */
export type TrackSource = (typeof TrackSource)[keyof typeof TrackSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrackSource = {
  ai: "ai",
  uploaded: "uploaded",
  arrangement: "arrangement",
} as const;
